var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.1fa863027cf90bbc3833749a23a810ce.svg#b';
                    var viewUrl = 'sprites.1fa863027cf90bbc3833749a23a810ce.svg#view-b';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 26 26',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };